<template>
    <a-card class="marketData">
        <div>
            <a-select allowClear @change="getOrganizationMarketData"
                      v-model="searchForm.organizationId"
                      style="width: 250px;"
                      optionFilterProp="title"
                      showSearch placeholder="请选择机构">
                <a-select-option :value="item.id" :title="item.name" v-for="item in organizationList">{{
                        item.name
                    }}
                </a-select-option>
            </a-select>
        </div>
        <div class="btn-group">
            <a-button-group>
                <a-button :type="searchForm.dateType === (index + 1) ? 'primary' : 'default'"
                          @click="dateChange(index + 1)"
                          v-for="(item, index) in dateType">
                    {{ item }}
                </a-button>
            </a-button-group>

            <a-button type="primary" @click="exportData">导出</a-button>
        </div>

        <a-table :columns="columns"
                 :scroll="{y: 350}"
                 rowKey="createTime"
                 :pagination="table.tablePagination"
                 :loading="table.tableLoading"
                 :dataSource="table.tableDataSource">
            <div slot="courseType" slot-scope="text">
                <span v-if="text.courseType === 1">测评课程</span>
                <span v-if="text.courseType === 2">训练课程</span>
            </div>
            <a slot="action" @click="look(text)" slot-scope="text">查看</a>
        </a-table>
    </a-card>
</template>

<script>
import {FormatDate, tableRelevant} from "@/pages/projectImpl/js/utils";
import XLSX from "xlsx";

const columns = [
    {
        title: '资源名称',
        dataIndex: 'courseName'
    },
    {
        title: '资源类型',
        scopedSlots: {customRender: 'courseType'},
    },
    {
        title: '添加日期',
        dataIndex: 'createTime'
    },
    {
        title: '总用量',
        dataIndex: 'maxUserCount'
    },
    {
        title: '完成率',
        dataIndex: 'completionRate'
    },
    {
        title: '截止昨日用量',
        dataIndex: 'preCycleConfigUserCount'
    },
    {
        title: '截止前日用量',
        dataIndex: 'prePreCycleConfigUserCount'
    },
    {
        title: '操作',
        scopedSlots: {customRender: 'action'},
    },
];
export default {
    name: 'marketData',
    data() {
        return {
            columns,
            searchForm: {
                organizationId: this.$store.getters["organization/getAnalysisOrganizationId"]() || undefined,
                dateType: 1
            },
            table: tableRelevant.call(this),
            organizationList: [],
            dateType: ['日', '周', '月', '年']
        }
    },
    created() {
        this.getOrganizationList();
        if (this.searchForm.organizationId) {
            this.getOrganizationMarketData();
        }
    },
    methods: {
        getOrganizationMarketData() {
            this.table.tableLoading = true;
            this.$store.commit("organization/setAnalysisOrganizationId", this.searchForm.organizationId || "");
            this.$http.TwoB.getOrganizationMarketData(this.searchForm).then(res => {
                const {data} = res;
                this.table.tableDataSource = data.map(m => {
                        m.completionRate = m.completionRate + "%";
                        return m;
                    });
                    this.table.tablePagination.total = data.length;
            }).finally(() => {
              this.table.tableLoading = false;
            })
        },
        look(val) {
            const Params = {organizationId: this.searchForm.organizationId};
            this.table.tableLoading = true;
            this.$http.User.checkOrganizationAuth(Params).then(res => {
                const {data} = res;
                if (data) {
                        this.$store.commit("organization/setOrganizationInfo", {
                            name: val.organizationName,
                            id: this.searchForm.organizationId
                        });
                        sessionStorage.setItem("ORGANIZATION_NAME", val.organizationName);
                        sessionStorage.setItem("ORGANIZATION_ID", this.searchForm.organizationId);
                        if (val.courseType === 1) {
                            this.$store.commit("organization/setActiveKey", 6);
                        } else {
                            this.$store.commit("organization/setActiveKey", 4);
                        }
                        this.$router.push("/projectImpl/pMechanism/orgDetails/page?id=" + this.searchForm.organizationId);
                    } else {
                        this.$message.error("无此机构数据权限");
                    }
            }).finally(() => {
              this.table.tableLoading = false;
            })
        },
        dateChange(val) {
            switch (val) {
                case 1:
                    this.columns[5].title = "截止昨日用量";
                    this.columns[6].title = "截止前日用量";
                    break;
                case 2:
                    this.columns[5].title = "截止上周用量";
                    this.columns[6].title = "截止前周用量";
                    break;
                case 3:
                    this.columns[5].title = "截止上月用量";
                    this.columns[6].title = "截止前月用量";
                    break;
                case 4:
                    this.columns[5].title = "截止去年用量";
                    this.columns[6].title = "截止前年用量";
                    break;
            }
            this.searchForm.dateType = val;
            this.getOrganizationMarketData();
        },
        getOrganizationList() {
            this.$http.loadAllByType({all: true}).then(res => {
                const {data} = res.data;
                this.organizationList = data;
                    this.filteredOptions = data;
            })
        },
        exportData() {
            this.$message.destroy();
            if (!this.table.tableDataSource.length) {
                this.$message.error("无课程营销数据");
                return
            }
            const workbook = XLSX.utils.book_new();
            const xlsxName = this.table.tableDataSource[0].organizationName
                + `课程营销三${this.dateType[this.searchForm.dateType - 1]}数据表`
                + FormatDate(Date.now(), "YYYYMMDDhhmmss");
            XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet([
                columns.map(m => m.title).filter(f => f !== "操作"),
                ...this.table.tableDataSource.map(m => {
                    return [
                        m.courseName,
                        m.courseType === 1 ? "测评课程" : m.courseType === 2 ? "训练课程" : "",
                        m.createTime,
                        m.maxUserCount,
                        m.completionRate,
                        m.preCycleConfigUserCount,
                        m.prePreCycleConfigUserCount,
                    ]
                })
            ]), '课程');
            // 保存为Excel文件
            XLSX.writeFile(workbook, xlsxName + '.xlsx');
        }
    }
}
</script>

<style scoped lang="less">
.marketData {
    height: 72.5vh;


    h1 {
        font-size: 22px;
    }

    .btn-group {
        display: flex;
        justify-content: space-between;
        margin: 20px 0;
    }
}
</style>
